var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.125 15C16.5392 15 16.875 15.3358 16.875 15.75C16.875 16.1642 16.5392 16.5 16.125 16.5H2.625C2.21079 16.5 1.875 16.1642 1.875 15.75C1.875 15.3358 2.21079 15 2.625 15H16.125ZM11.8857 1.5C12.0846 1.50002 12.2754 1.57907 12.416 1.71973L15.1553 4.45996C15.448 4.75282 15.448 5.22764 15.1553 5.52051L7.39941 13.2803C7.2588 13.4209 7.06803 13.4999 6.86914 13.5H4.125C3.71079 13.5 3.375 13.1642 3.375 12.75V10.0195C3.37511 9.82093 3.45437 9.63076 3.59473 9.49023L11.3555 1.71973C11.4961 1.57914 11.6869 1.50004 11.8857 1.5ZM4.875 10.3301V12H6.55859L13.5645 4.99023L11.8857 3.31152L4.875 10.3301Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.0f8fa52201a1a6c37e76bab7c221e726.svg";
export { ForwardRef as ReactComponent };